import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContentTableCell = styled(TableCell)((props) => ({
	color: props.theme.palette.common.black,
	fontWeight: 800,
	fontSize: '14px',
}));
